import BeneficialOwner from '@company-common/model/kyc-form/BeneficialOwner'
import CustomBOPParticulars from '@company-common/model/kyc-form/CustomBOPParticulars'
import Validation from '@core/logic/Validation'

export default class BeneficialOwnerValidation extends Validation {
  validate (bo: BeneficialOwner, belongsTo: string) {
    this.belongsTo = belongsTo
    const { getMessages, ADD, REQUIRE, REQUIRE_TRUE, WHEN } = this.validator()
    ADD(REQUIRE(bo.declarationBeneficialOwner, 'Declaration of Beneficial Owner must be filled'), ['Client\'s Declaration'], ['declarationBeneficialOwner'])
    ADD(WHEN(bo.declarationBeneficialOwner === 'no', () => {
      if (!bo.beneficialOwnerParticulars || this.isEmpty(bo.beneficialOwnerParticulars)) {
        return 'Beneficial Owner details should be filled'
      }

      let errorMsg = null
      if (this.isBeneficialOwnerDetailsNotFilled(bo.beneficialOwnerParticulars)) {
        errorMsg = 'Beneficial Owner Details is not filled properly.'
      }
      return errorMsg
    }), ['Beneficial Owner Particulars Form'], [
      'contactNumber',
      'correspondenceAddress',
      'dateOfBirth',
      'fullName',
      'nationality',
      'nric',
      'reasonsForAppointment',
      'relationshipToCustomer',
      'residentialAddress'
    ])

    return getMessages()
  }

  isBeneficialOwnerDetailsNotFilled (beneficialOwner: CustomBOPParticulars) {
    return this.isEmpty(beneficialOwner.contactNumber) ||
    this.isEmpty(beneficialOwner.correspondenceAddress) ||
    this.isEmpty(beneficialOwner.dateOfBirth) ||
    this.isEmpty(beneficialOwner.fullName) ||
    this.isEmpty(beneficialOwner.nationality) ||
    this.isEmpty(beneficialOwner.nric) ||
    // this.isEmpty(beneficialOwner.politicallyExposedPerson) ||
    this.isEmpty(beneficialOwner.reasonsForAppointment) ||
    this.isEmpty(beneficialOwner.relationshipToCustomer) ||
    this.isEmpty(beneficialOwner.residentialAddress)
  }
}
